export default "__VITE_ASSET__BKVWabvz__ 480w, __VITE_ASSET__B_zvVX$5__ 768w, __VITE_ASSET__wLsI$stj__ 1200w";